import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiagramsDotNetComponent } from './simple-icons-diagrams-dot-net.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiagramsDotNetComponent ],
    exports:      [ SimpleIconsDiagramsDotNetComponent ],
    bootstrap:    []
})
export class SimpleIconsDiagramsDotNetModule {}
